import React from "react";
import { Helmet } from "react-helmet-async";

const PageMeta = ({ metaData }) => {
    if (!metaData) return null;

    return (
        <Helmet>
            {metaData.meta_title && (
                <title>{metaData.meta_title}</title>
            )}

            {metaData.meta_description && (
                <meta name="description" content={metaData.meta_description} />
            )}

            {metaData.meta_keyword && (
                <meta name="keywords" content={metaData.meta_keyword} />
            )}
        </Helmet>
    );
};

export default PageMeta;